import './ClientMission.scss';
import Store from 'state/Store';
import React from 'react';
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg';
import IconMap from './IconMap';
import ProgressTracker from '../ProgressTracker/ProgressTracker';
import {
  expandSubSteps,
  isMissionActive,
  mapProgressStep,
  MISSION_STATUS
} from './utils/MissionUtils';
import { confirmSubmissionNav } from 'services/OnBoardingJourney';
import {
  setStepModalAction,
  setStepModalAgreementID,
  setStepModalOpen
} from 'state/missions/MissionActions';
import { dispatchOverlayLoad } from 'state/logic/AnalyticsLogic';
import { isTaxableAccount } from 'services/AccountTypes';

const ClientMission = ({ account, fundingType, steps: missionSteps = [] }) => {
  return missionSteps.map((step, i) => {
    const { action, missionName, steps: subSteps = [], missionStatus } = step;
    const taxableSweep = isTaxableAccount(account?.accountTypeId);
    const subStepsOpen = expandSubSteps(missionStatus, action, fundingType);
    const active = isMissionActive(missionStatus);
    const showChevron = active ? true : false;
    //TODO: Possible this may need to check length if service does not return substeps for 30-day
    const progressSteps = subSteps.map(mapProgressStep);
    /// TODO: add status className - because pointer
    return (
      <div key={i} className={`mission-container ${active ? 'active' : ''}`} >
        <button
          className="mission-header"
          aria-label={active ? 'Ready to fund' : 'Completed Application'}
          onClick={() => {
            if (missionStatus !== MISSION_STATUS.COMPLETED) {
              Store.dispatch(setStepModalAgreementID(account.accountId));
              if (action === 'FUNDING' && fundingType !== 'NONE') {
                confirmSubmissionNav(fundingType, account);
              } else {
                Store.dispatch(setStepModalAction(action));
                Store.dispatch(setStepModalOpen());
                if(action === 'FUNDING') {
                  dispatchOverlayLoad(taxableSweep ? "Choose your sweep account funding method – Taxable" : "Choose your sweep account funding method – Nontaxable");
                }
              }
            }
          }}>
          <IconMap
            action={action}
            currentIndex={i + 1}
            status={missionStatus}
            name={missionName}
          />
          <div className="mission-name">{missionName}</div>
          {showChevron && (
            <ChevronRight className={'step-modal-trigger'} />
          )}
        </button>
        {subSteps && subStepsOpen && (
          <div className="sub-steps-container">
            <ProgressTracker
              steps={progressSteps}
              activeStep={progressSteps.find((step) => {
                const { missionStatus: status } = step;
                return isMissionActive(status);
              })}
            />
          </div>
        )}
      </div>
    );
  });
};

export default ClientMission;
